const EXCLUDED_PATH_PATTERNS = [
  '.svg',
  '.png',
  '.webp',
  '.js',
  '.ico',
  '/giris',
  '/uye/kisisel-bilgilerim/hesabimi-sil',
  '/parola-guncelle',
  '/parola-unuttum',
  '/parola-unuttum/sonuc',
];

export const isExcluded = (pathname: string) =>
  EXCLUDED_PATH_PATTERNS.some(
    (p) =>
      p.startsWith('.') // we check the end part of the pathname to see if path starts with .
        ? pathname.endsWith(p)
        : pathname === p // otherwise check for strict equality so /finansal-skor/giris does not return true due to '/giris' being excluded
  );
